var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailResend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    className: "size-lg stroke-1 text-primary",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.7495C14.0711 15.7495 15.75 14.0706 15.75 11.9995C15.75 9.92844 14.0711 8.24951 12 8.24951C9.92893 8.24951 8.25 9.92844 8.25 11.9995C8.25 14.0706 9.92893 15.7495 12 15.7495Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.976 19.4997C15.3051 20.6086 13.3118 21.1278 11.3122 20.9748C9.31273 20.8218 7.42156 20.0055 5.93881 18.6553C4.45607 17.3052 3.46668 15.4985 3.12763 13.522C2.78859 11.5455 3.11931 9.51242 4.06731 7.74529C5.01532 5.97816 6.52632 4.57822 8.36055 3.76762C10.1948 2.95702 12.2472 2.78217 14.1921 3.27083C16.137 3.75949 17.863 4.88366 19.0963 6.46497C20.3295 8.04628 20.9994 9.99415 20.9996 11.9995C20.9996 14.0706 20.2496 15.7495 18.3746 15.7495C16.4996 15.7495 15.7496 14.0706 15.7496 11.9995V8.24952",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailResend);
export default __webpack_public_path__ + "static/media/email-resend.a0f8e1ee3ab425529764aa5ee6c44e0d.svg";
export { ForwardRef as ReactComponent };